import { Button } from 'antd';

import './customComponent.scss';
import { useTranslation } from 'react-i18next';

const CancelBtn = (props: any) => {
    const { className } = props;
    const {t} = useTranslation('common');
    const customClassName = `${className} custom-cancel-button`;

    return (
        <Button
            {...props}
            {...{ className: customClassName }}
            type="text"
            htmlType="button"
            className="cancel-button"
        >
            {"Cancel"}
        </Button>
    );
};

export default CancelBtn;
